import kamala from '../../kamala'
import Icon from './Icon'

Icon.install = function (Vue) {
  kamala(Vue)
  Vue.component(Icon.name, Icon)
}

export {
  Icon,
}

export default Icon
